let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jmlf9")).then(() => parcelRequire('8kvot'));